<template>
  <span>
    <template v-if="href">
      <a :href="href" target="_blank">
        <span v-if="!hideText" class="external-link">{{ text || href }}</span>
        <v-icon style="color: #1E77D1" small>launch</v-icon>
      </a>
    </template>
    <template v-else>-</template>
  </span>
</template>

<script>
export default {
  props: {
    href: String,
    text: {
      type: String,
      required: false
    },
    hideText: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  name: 'ExternalLink'
}
</script>

<style lang="sass">
.external-link
  display: inline-block
  max-width: 460px
  overflow: hidden
  text-overflow: ellipsis
  white-space: nowrap
  vertical-align: top
</style>
